import Icon from '../components/Icon.vue'

Icon.register({"file-photo-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM1280 1216v320h-1024v-192l192-192 128 128 384-384zM448 1024q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-photo-o.js
// module id = 286
// module chunks = 0